import React, { Fragment } from 'react';
import { bool, func, object, string } from 'prop-types';
import { intlShape } from 'react-intl';
import classNames from 'classnames';

import { IconArrowNavigation } from '../../Icons';
import {
  ModalSwimmy,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
} from '../../ModalSwimmy';

import HeaderDesktop from '../HeaderDesktop/HeaderDesktop';
import BasePricingForm from './BasePricingForm/BasePricingForm';
import css from './BasePricingView.module.css';

const BasePricingView = (props) => {
  const {
    className,
    intl,
    isMobile,
    isOpen,
    listing,
    onCloseModal,
    onManageDisableScrolling,
    onSubmit,
    updated,
    updateInProgress,
  } = props;
  const headingText = intl.formatMessage({ id: 'EditListingPricingPanel.BasePricingView.title' });
  const informationText = intl.formatMessage({ id: 'EditListingPricingPanel.BasePricingView.information' });
  const classes = classNames(css.root, className);
  const content = (
    <Fragment>
      <div className={css.information}>
        <span>{informationText}</span>
      </div>
      <BasePricingForm
        intl={intl}
        isMobile={isMobile}
        listing={listing}
        onSubmit={onSubmit}
        updated={updated}
        updateInProgress={updateInProgress}
      />
    </Fragment>
  );

  return isMobile ? (
    <ModalSwimmy
      id="basePricing"
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <ModalOverlay />
      <ModalContent
        className={css.modalContent} 
        animationType="slideRight"
        show={isOpen}
      >
        <ModalHeader className={css.modalHeader}>
          <button className={css.backButton} onClick={onCloseModal}>
            <IconArrowNavigation direction="left" />
          </button>
          <span className={css.heading}>{headingText}</span>
          <div className={css.spacer} />
        </ModalHeader>
        <ModalBody className={css.modalBody}>
          {content}
        </ModalBody>
      </ModalContent>
    </ModalSwimmy>
  ) : isOpen ? (
    <Fragment>
      <HeaderDesktop className={css.headerDesktop} heading={headingText} intl={intl} />
      <div className={css.contentDesktop}>
        {content}
      </div>
    </Fragment>
  ) : null;
}

BasePricingView.defaultProps = {
  className: null,
  listing: null,
};

BasePricingView.propTypes = {
  className: string,
  intl: intlShape.isRequired,
  isMobile: bool.isRequired,
  isOpen: bool.isRequired,
  listing: object,
  onCloseModal: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  onSubmit: func.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
};

export default BasePricingView;